import { useEffect, useState } from "react";

const TTL_MS = 15 * 60 * 1000;
const TTL = { "fs-invite-token": 3 * 60 * 60 * 1000 };  // invitations: long enough to create an account and confirm email in this tab

// Reads a one-time token from the URL fragment (#t=…; never sent to servers), keeps it only in this tab's
// sessionStorage for 15 minutes so it survives sign-in, strips it from the address bar, and suppresses referrers.
function capture(key) {
    const frag = new URLSearchParams(window.location.hash.slice(1));
    const fresh = frag.get("t");
    if (fresh) {
      sessionStorage.setItem(key, JSON.stringify({ t: fresh, optout: frag.get("optout") === "1", at: Date.now() }));
      window.history.replaceState(window.history.state, "", window.location.pathname);
    }
    try {
      const saved = JSON.parse(sessionStorage.getItem(key) || "null");
      if (saved && Date.now() - saved.at < (TTL[key] || TTL_MS)) return { token: saved.t, optout: !!saved.optout };
    } catch { /* ignore */ }
    sessionStorage.removeItem(key);
    return { token: "", optout: false };
}

export function useFragmentToken(key) {
  const [state, setState] = useState(() => capture(key));
  useEffect(() => {
    const onHash = () => { if (window.location.hash.includes("t=")) setState(capture(key)); };
    window.addEventListener("hashchange", onHash);
    return () => window.removeEventListener("hashchange", onHash);
  }, [key]);
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "referrer"; meta.content = "no-referrer";
    document.head.appendChild(meta);
    return () => meta.remove();
  }, []);
  return { ...state, clear: () => sessionStorage.removeItem(key) };
}
